import { 
  facilityTypeFilterForm, facilityTypeDrawerForm, facilityTypeDrawerFormRules,
  facilityDataFilterForm, facilityDataDrawerForm, facilityDataDrawerFormRules,
  aircraftFilterForm, aircraftDrawerForm, aircraftDrawerFormRules,
  groundResourcesTypeFilterForm, groundResourcesTypeDrawerForm, groundResourcesTypeDrawerFormRules,
  groundResourcesDataFilterForm, groundResourcesDataDrawerForm, groundResourcesDataDrawerFormRules,
  airspaceFilterForm, airspaceDrawerForm, airspaceDrawerFormRules,
  airApproachControlFilterForm, airApproachControlDrawerForm, airApproachControlDrawerFormRules,
  airlineEnquiryFilterForm,
  emergencyFilterForm, emergencyDrawerForm, emergencyDrawerFormRules,
  alarmFilterForm,
  roleFilterForm, roleDrawerForm, roleDrawerFormRules,
  systemUserFilterForm,
  enterpriseCertificationFilterForm, 
  pilotCertificationFilterForm,
  flightPlanManagementFilterForm,
  satelliteFilterForm
 } from '@/utils/formSetting'
import { 
  facilityTypeHeader, facilityDataHeader, aircraftHeader, groundResourcesTypeHeader, groundResourcesDataTypeHeader,
  airspaceHeader, airApproachControlHeader, airlineEnquiryHeader,
  emergencyHeader,
  alarmHeader,
  roleHeader, systemUserHeader, enterpriseCertificationHeader, pilotCertificationHeader,
  flightPlanManagementHeader ,satelliteManagementHeader } from '@/utils/tableSetting.js'


export const filterFormMap = {
  facilityType: facilityTypeFilterForm,
  facilityData: facilityDataFilterForm,
  aircraft: aircraftFilterForm,
  groundResourcesType: groundResourcesTypeFilterForm,
  groundResourcesData: groundResourcesDataFilterForm,
  airspace: airspaceFilterForm,
  airApproachControl: airApproachControlFilterForm,
  airlineEnquiry: airlineEnquiryFilterForm,
  emergency: emergencyFilterForm,
  alarm: alarmFilterForm,
  role: roleFilterForm,
  systemUser: systemUserFilterForm,
  enterpriseCertification: enterpriseCertificationFilterForm,
  pilotCertification: pilotCertificationFilterForm,
  management:flightPlanManagementFilterForm,
  satellite:satelliteFilterForm
}
export const drawerFormMap = {
  facilityType: facilityTypeDrawerForm,
  facilityData: facilityDataDrawerForm,
  aircraft: aircraftDrawerForm,
  groundResourcesType: groundResourcesTypeDrawerForm,
  groundResourcesData: groundResourcesDataDrawerForm,
  airspace: airspaceDrawerForm,
  airApproachControl: airApproachControlDrawerForm,
  role: roleDrawerForm,
  emergency: emergencyDrawerForm,
}
export const drawerFormRuleMap = {
  facilityType: facilityTypeDrawerFormRules,
  facilityData: facilityDataDrawerFormRules,
  aircraft: aircraftDrawerFormRules,
  groundResourcesType: groundResourcesTypeDrawerFormRules,
  groundResourcesData: groundResourcesDataDrawerFormRules,
  airspace: airspaceDrawerFormRules,
  airApproachControl: airApproachControlDrawerFormRules,
  role: roleDrawerFormRules,
  emergency: emergencyDrawerFormRules,
}
export const tableHeaderMap = {
  facilityType: facilityTypeHeader,
  facilityData: facilityDataHeader,
  aircraft: aircraftHeader,
  groundResourcesType: groundResourcesTypeHeader,
  groundResourcesData: groundResourcesDataTypeHeader,
  airspace: airspaceHeader,
  airApproachControl: airApproachControlHeader,
  airlineEnquiry: airlineEnquiryHeader,
  emergency: emergencyHeader,
  alarm: alarmHeader,
  role: roleHeader,
  systemUser: systemUserHeader,
  enterpriseCertification: enterpriseCertificationHeader,
  pilotCertification: pilotCertificationHeader,
  management:flightPlanManagementHeader,
  satellite:satelliteManagementHeader
}

export const tableTitleMap = {
  facilityType: '设施设备类型',
  aircraft: '飞行器',
  facilityData: '设施设备数据',
  groundResourcesType: '地面资源类型',
  groundResourcesData: '地面资源数据',
  airspace: '空域数据',
  airlineEnquiry: '航线查询',
  role: '角色',
  systemUser: '用户',
  enterpriseCertification: '企业认证',
  pilotCertification: '飞行员认证',
  airApproachControl: '航线数据',
  management: '飞行任务',
  emergency: '救援数据',
  alarm: '告警数据',
  satellite:"热源监测管理"
}

// 面包屑
export const breadcrumbSet = {
  aircraft: [
    {
      name: '数据管理',
      path: '/dataManagement/aircraft'
    },
    {
      name: '飞行器管理'
    }
  ],
  facilityType: [
    {
      name: '数据管理',
      path: '/dataManagement'
    }, 
    {
      name: '设施设备管理',
      path: '/dataManagement/facility'
    }, 
    {
      name: '设施设备类型管理'
    }
  ],
  facilityData: [
    {
      name: '数据管理',
      path: '/dataManagement'
    }, 
    {
      name: '设施设备管理',
      path: '/dataManagement/facility'
    }, 
    {
      name: '设施设备数据管理'
    }
  ],
  dataDetail: [
    {
      name: '数据管理',
      path: '/dataManagement'
    },
    {
      name: '飞行器管理',
      path: '/dataManagement/aircraft'
    },
    {
      name: '飞行器详情'
    }
  ],
  groundResourcesType: [
    {
      name: '数据管理',
      path: '/dataManagement'
    }, 
    {
      name: '地面资源管理',
      path: '/dataManagement/groundResources'
    }, 
    {
      name: '地面资源类型管理'
    }
  ],
  groundResourcesData: [
    {
      name: '数据管理',
      path: '/dataManagement'
    }, 
    {
      name: '地面资源管理',
      path: '/dataManagement/groundResources'
    }, 
    {
      name: '地面资源数据管理'
    }
  ],
  declaration: [
    {
      name: '飞行计划',
      path: '/flightPlan'
    }, 
    {
      name: '飞行计划申报'
    }
  ],
  alteration: [
    {
      name: '飞行计划',
      path: '/flightPlan'
    }, 
    {
      name: '飞行计划变更'
    }
  ],
  accraditation: [
    {
      name: '飞行计划',
      path: '/flightPlan'
    }, 
    {
      name: '飞行计划审批'
    }
  ],
  management: [
    {
      name: '飞行计划',
      path: '/flightPlan'
    }, 
    {
      name: '飞行任务管理'
    }
  ],
  newFlightPlane: [
    {
      name: '飞行计划',
      path: '/flightPlan'
    }, 
    {
      name: '飞行任务管理',
      path: '/flightPlan/management'
    },
    {
      name: '新增飞行任务'
    }
  ],
  planDetails: [
    {
      name: '飞行计划',
      path: '/flightPlan'
    }, 
    {
      name: '飞行计划管理',
      path: '/flightPlan/management'
    },
    {
      name: '飞行计划详情'
    }
  ],
  report: [
    {
      name: '飞行计划',
      path: '/flightPlan'
    }, 
    {
      name: '飞行计划报告'
    }
  ],
  airspace: [
    {
      name: '飞行调度',
      path: '/flightSchedule'
    }, 
    {
      name: '空域管理'
    }
  ],
  airApproachControl: [
    {
      name: '飞行调度',
      path: '/flightSchedule'
    }, 
    {
      name: '航线管理'
    }
  ],
  newAirline: [
    {
      name: '飞行调度',
      path: '/flightSchedule'
    }, 
    {
      name: '航线管理',
      path: '/flightSchedule/airApproachControl'
    },
    {
      name: '航线'
    }
  ],
  courseDetails: [
    {
      name: '飞行调度',
      path: '/flightSchedule'
    }, 
    {
      name: '航线查询',
      path: '/flightSchedule/airlineEnquiry'
    },
    {
      name: '航线详情'
    }
  ],
  airlineEnquiry: [
    {
      name: '飞行调度',
      path: '/flightSchedule'
    }, 
    {
      name: '航线查询'
    }
  ],
  aircraftStatistics: [
    {
      name: '飞行数据分析统计度',
      path: '/dataStatistics'
    }, 
    {
      name: '飞行器统计分析'
    }
  ],
  rescue: [
    {
      name: '飞行数据分析统计度',
      path: '/dataStatistics'
    }, 
    {
      name: '救援统计分析'
    }
  ],
  alarmStatistics: [
    {
      name: '飞行数据分析统计度',
      path: '/dataStatistics'
    }, 
    {
      name: '告警统计分析'
    }
  ],
  userRegister: [
    {
      name: '飞行数据分析统计度',
      path: '/dataStatistics'
    }, 
    {
      name: '用户注册统计分析'
    }
  ],
  emergency: [
    {
      name: '救援管理',
      path: '/emergencyManagement'
    }, 
    {
      name: '救援管理'
    }
  ],
  alarm: [
    {
      name: '告警管理',
      path: '/alarmManagement'
    }, 
    {
      name: '告警管理'
    }
  ],
  role: [
    {
      name: '用户管理',
      path: '/userManagement'
    }, 
    {
      name: '角色管理'
    }
  ],
  systemUser: [
    {
      name: '用户管理',
      path: '/userManagement'
    }, 
    {
      name: '系统用户管理'
    }
  ],
  pilotCertification: [
    {
      name: '用户管理',
      path: '/userManagement'
    }, 
    {
      name: '飞行员认证管理'
    }
  ],
  enterpriseCertification: [
    {
      name: '用户管理',
      path: '/userManagement'
    }, 
    {
      name: '企业认证管理'
    }
  ],
  information: [ 
    {
      name: '个人中心',
      path: '/personalCenter'
    }, 
    {
      name: '个人信息'
    }
  ],
  enterprise: [ 
    {
      name: '个人中心',
      path: '/personalCenter'
    }, 
    {
      name: '企业认证'
    }
  ],
  pilot: [ 
    {
      name: '个人中心',
      path: '/personalCenter'
    }, 
    {
      name: '飞行员认证'
    }
  ],
  satelliteManagement:[
	{
	  name: '卫星遥感监测',
	  path: '/satelliteManagement'
	},
	{
	  name: '热源监测',
	}, 
  ]
}
export const leftNavMenu = {
  
  'dataManagement': [
    {
      icon: 'Stopwatch',
      name: '飞行器管理',
      path: '/dataManagement/aircraft',
      type: 'aircraft',
    },
    {
      icon: 'Box',
      name: '设施设备管理',
      path: '/dataManagement/facilityType',
      type: 'facility',
      children: [
        {
          name: '设施设备类型管理',
          path: '/dataManagement/facility/facilityType',
          type: 'facilityType',
        },
        {
          name: '设施设备数据管理',
          path: '/dataManagement/facility/facilityData',
          type: 'facilityData',
        },
      ]
    },
    {
      icon: 'Loading',
      name: '地面资源管理',
      path: '/dataManagement/groundResources',
      type: 'hotType',
      children: [
        {
          name: '地面资源类型管理',
          path: '/dataManagement/groundResources/groundResourcesType',
          type: 'groundResourcesType',
        },
        {
          name: '地面资源数据管理',
          path: '/dataManagement/groundResources/groundResourcesData',
          type: 'groundResourcesData',
        },
      ]
    },
    
  ],
  'flightPlan': [
    {
      icon: 'Box',
      name: '飞行计划管理',
      path: '/flightPlan/management',
      type: 'management',
    } 
  ],
  'flightSchedule': [
    {
      icon: 'Stopwatch',
      name: '空域管理',
      path: '/flightSchedule/airspace',
      type: 'airspace',
    },
    {
      icon: 'SetUp',
      name: '航线管理',
      path: '/flightSchedule/airApproachControl',
      type: 'airApproachControl',
    },
    {
      icon: 'Tickets',
      name: '航线查询',
      path: '/flightSchedule/airlineEnquiry',
      type: 'airlineEnquiry',
    },
  ],
  'dataStatistics': [
    {
      icon: 'DataAnalysis',
      name: '飞行器统计分析',
      path: '/dataStatistics/aircraftStatistics',
      type: 'aircraftStatistics',
    },
    {
      icon: 'DataLine',
      name: '救援统计分析',
      path: '/dataStatistics/rescue',
      type: 'rescue',
    },
    {
      icon: 'Tickets',
      name: '告警统计分析',
      path: '/dataStatistics/alarmStatistics',
      type: 'alarmStatistics',
    },
    {
      icon: 'Tickets',
      name: '用户注册统计分析',
      path: '/dataStatistics/userRegister',
      type: 'userRegister',
    },
  ],
  'emergencyManagement': [
    {
      icon: 'Help',
      name: '救援管理',
      path: '/emergencyManagement/emergency',
      type: 'emergency',
    },
  ],
  'alarmManagement': [
    {
      icon: 'Stopwatch',
      name: '告警管理',
      path: '/alarmManagement/alarm',
      type: 'alarm',
    },
  ],
  'userManagement': [
    {
      icon: 'MessageBox',
      name: '角色管理',
      path: '/userManagement/role',
      type: 'role',
      permission: 'PC-角色管理:查询'
    },
    {
      icon: 'User',
      name: '用户管理',
      path: '/userManagement/systemUser',
      type: 'systemUser',
      permission: 'PC-用户管理:查询'

    },
    {
      icon: 'FolderChecked',
      name: '企业认证管理',
      path: '/userManagement/enterpriseCertification',
      type: 'enterpriseCertification',
    },
    {
      icon: 'DocumentAdd',
      name: '飞行员认证管理',
      path: '/userManagement/pilotCertification',
      type: 'pilotCertification',
    },
  ],
  'personalCenter': [
    {
      icon: 'Postcard',
      name: '个人信息',
      path: '/personalCenter/information',
      type: 'information',
    },
    {
      icon: 'Stopwatch',
      name: '企业认证',
      path: '/personalCenter/enterprise',
      type: 'enterprise',
    },
    {
      icon: 'Stopwatch',
      name: '飞行员认证',
      path: '/personalCenter/pilot',
      type: 'pilot',
    },
  ],
  
  'satelliteManagement':[
	  {
		icon:'Help',
		name:'热源监测',
		path: '/satelliteManagement/satelliteManagement',
		type:'satelliteManagement'
	  }
  ]
  
}
export const checkStatusMap = {
  '待审核': 'pending',
  '审核中': 'reviewing',
  '审核通过': 'pass',
  '审核不通过': 'fail',
}
export const checkStatusReverseMap = {
  pending: '待审核',
  reviewing: '审核中',
  pass: '审核通过',
  fail: '审核不通过',
}
export const dataDetailsMap = {
  info: {
    series: '飞行器编号',
    deviceNumber: '飞行器设备号',
    subordinateCompany: '飞行器所属公司',
    deviceMmsi: '飞行器MMSI', 
    purpose: '飞行器用途',
    contactPerson: '飞行器联络人',
    devicePictures: '飞行器图片'
  },
  params: {
    maxFlyWeight: '最大起飞重量（kg）',
    maxEmptyFlyWeight: '最大空机重量（kg）',
    maxFlySpeed: '最高飞行速度（kts）',
    flyMachineDiameter: '机身最大直径（m）',
    maxFlyTime: '最大续航时长（min）',
    loadPeopleNum: '核载人数（人）'
  },
  flyParams: {
    lastFlyDate: '最后飞行时间',
    startDistance: '起飞距离（m）',
    landingDistance: '降落距离（m）',
    startPort: '飞行航线',
    takeOffGlideDistance: '起飞滑行距离（m）',
    landingSlideDistance:'降落滑行距离（m）',
    lon: '最后上报经度',
    lat: '最后上报纬度',
    offGroundSpeed: '离地速度（kts）',
    groundingSpeed: '接地速度（kts）',
    voyageTime: '航行时长',
    realMaxFlySpeed: '最高飞行速度（kts）',
    routeDistance: '航线里程（m）'
  }
}
export const courseDetailsMap = {
  startStation: '出发站点',
  origin: '航路来源',
  endStation: '到达站点',
  searchSum: '查询次数',
  count: '航线站点',
  routeDistance: '全程里程',
  dirDistance: '直飞距离',
  searchDate: '查询时间',  
}
export const planDetailsMap = {
  planName: '计划名称',
  planSer: '计划编号',
  planClass: '计划类型',
  startStation : '起始站点',
  stopStation: '停靠站点',
  endStation: '终点站点',
  flyDate: '执飞日期',
  stopTime: '站点停靠时间',  
  launchTime: '预计起飞时间',  
  landTime: '预计降落时间',  
  flyClass: '飞行器类型',  
  pic: '航线轨迹图',  
  hight: '飞行高度',  
  speed: '预定航速',  
  wholeDistance: '航线总里程',  
  takeTime: '预计全程用时',  
  createTime: '创建时间',  
  mark: '备注',  

}

export const userInformationMap = {
  id: '用户序号',
  userName: '账号名称',
  authenticatedName: '认证名称',
  company: '所属企业',
  flyAuthenticatedStatus: '飞行员认证',
  mobile: '手机号码',
  password: '修改密码'
}
export const dialogFromBtn = [
  {
    btnType: 'primary',
    label: '确定删除',
    key: 'delete'
  },
  {
    btnType: 'primary',
    label: '保存',
    key: 'save'
  },
  {
    btnType: 'primary',
    label: '导入',
    key: 'import'
  },
  {
    btnType: 'primary',
    label: '导出',
    key: 'export'
  },
  {
    label: '取消',
    key: 'cancel'
  },
  {
    btnType: 'primary',
    label: '关闭',
    key: 'close'
  },
]

export const certificationStatusMap = {
  '认证成功': 'authorizedSuccess',
  '认证失败': 'authorizedFailure',
  '待审核': 'authenticating',
  '未认证': 'unauthorized',
}
export const certificationStatusTableMap = {
  'authorizedSuccess': '认证成功',
  'authorizedFailure': '认证失败', 
  'authenticating': '待审核', 
  'unauthorized': '未认证', 
}
export const certificationTypeMap = {
  '个人认证': 'oneself', // 'personalCertificate',
  '企业认证': 'company' // 'enterpriseCertificate'
}
export const certificationTypeTableMap = {
  'oneself': '个人认证', // 'personalCertificate',
  'company': '企业认证' // 'enterpriseCertificate'
}

export const flightPlanCheckStatusTableMap = {
  hasUploaded: '待审核',
  pass: '通过', 
  failed: '不通过'
}
export const emergencyStatusTableMap = {
  pendingRescue: '待救援',
  rescuing: '正在救援', 
  rescued: '已救援'
}
export const emergencyStatusMap = {
  '待救援': 'pendingRescue',
  '正在救援': 'rescuing',
  '已救援': 'rescued',
}

export const alarmStatusTableMap = {
  pending: '待处理',
  dealed: '已处理'
}
export const alarmStatusMap = {
  '待处理': 'pending',
  '已处理': 'dealed'
}

export const warningInfoIconMap = {
  '飞行冲突': 'flightConflict',
  '气象恶劣': 'badWeather',
  '偏离航线': 'offCourse',
  '故障告警': 'faultAlarm',
}

export const baseParamsMap = {
  maximumTakeoffWeight: '最大起飞重量(kg)',
  maximumFuselageDiameter: '机身最大直径(m)',
  maximumEmptyWeight: '最大空机重量(kg)',
  maximumEndurance: '最大续航时长(min)',
  maximumFlyingSpeed: '最高飞行速度(kts)',
  nuclearLoad: '核载人数(人)',
  takeOffDistance: '起飞距离(m)',
  coastingDistance: '起飞滑行距离(m)',
  unstickSpeed: '离地速度(kts)',
  slipDistance: '降落距离(m)',
  touchdownSpeed: '接地速度(kts)'
}
export const unitMap={
  GPS_RAW_INT: {
    lat: 'deg',
    lon: 'deg',
    alt: 'm',
    eph: 'm',
    epv: 'm',
    satellitesVisible : '个',
    cog : 'deg',
  },
  GLOBAL_POSITION_INT: {
    lat_g: 'deg',
    lon_g: 'deg',
    alt_g: 'm',
    relativeAlt: 'm',
    vx: 'm/s',
    vy: 'm/s',
    vz: 'm/s',
  },
  ATTITUDE: {
    roll: 'deg',
    pitch: 'deg',
    yaw: 'deg',
    rollspeed: 'deg/s',
    pitchspeed: 'deg/s',
    yawspeed: 'deg/s',
  },
  VfrHud:{
    heading:'deg',
    climb:'m/s',
  },
}
export const flyParamsMap = {
  // systemStatus: {
  //   voltageBattery: '电池电压',
  //   currentBattery: '工作电流',
  //   batteryRemaining: '电池余量',
  //   dropRateComm: '丢包率',
  //   errorsComm: '丢包总计',
  // },
  GPS_RAW_INT: {
    fixType: 'GPS定位类型',
    lat: '纬度',
    lon: '经度',
    alt: '高度',
    eph: '水平定位精度',
    epv: '垂直定位精度',
    satellitesVisible : '可见卫星数',
    cog : '整体移动方向',
  },
  // gpsData: {
  //   alt: '海拔高度',
  //   eph: '水平定位精度',
  //   epv: '垂直定位精度',
  //   vel: '地速',
  //   cog: '方向',
  //   satellitesVisible: '可见卫星数',
  // },
  GLOBAL_POSITION_INT: {
    lat_g: '纬度',
    lon_g: '经度',
    alt_g: '高度',
    relativeAlt: '相对高度',
    vx: '地面x速度',
    vy: '地面y速度',
    vz: '地面z速度',
  },
  // globalData: {
  //   alt: '海拔高度',
  //   relativeAlt: '地面相对高度',
  //   vx: 'X 地速',
  //   vy: 'Y 地速',
  //   vz: 'Z 地速',
  //   hdg: '罗盘',
  // },
  ATTITUDE: {
    roll: '横滚角',
    pitch: '俯仰角',
    yaw: '偏航角',
    rollspeed: '横滚角速度',
    pitchspeed: '俯仰角速度',
    yawspeed: '偏航角速度',
  },
  // attitude: {
  //   roll: '滚转角',
  //   pitch: '俯仰角',
  //   yaw: '偏航角',
  //   rollspeed: '滚转角速度',
  //   pitchspeed: '俯仰角速度',
  //   yawspeed: '偏航角速度',
  //   airspeed: '空速',
  //   groundspeed: '地速',
  //   heading: '航向',
  //   throttle: '油门',
  //   climb: '爬升率',
  // },
  onboardControlSensorsPresent: {
    'gyroscope3D':'三轴陀螺仪',
    'accelerometer3D':'三轴加速度计',
    'magneticCompass3D':'三轴磁罗盘',
    'absoluteBarometer':'绝对气压计',
    'relativeBarometer':'相对气压计',
    'gPS':'全球定位系统',
    // 'opticalMeasurementEquipment':'光测设备',
    // 'computerVisionLocation':'计算机视觉定位仪',
    // 'laserPositioning':'激光定位',
    // 'externalLaserPositioning':'外部激光定位',
    // 'angularVelocityController3D':'三轴角速度控制器',
    // 'heightStabilizer':'高度稳定器',
    // 'directionStabilizer':'方向稳定器',
    // 'heightController':'高度控制器',
    // 'positionController':'x/y位置控制器',
    // 'motorOutputController':'马达输出控制器',
  },
  Heartbeat:{
    systemStatus:'飞行状态',
    type:'飞行器类型',
  },
  VfrHud:{
    heading:'航向',
    climb:'爬升率',
  },
}
export const flyParamsTitleMap = {
  // systemStatus: '系统状态',
  GPS_RAW_INT: 'GPS 数据',
  // gpsData: 'GPS 数据',
  // globalData: '全球定位数据',
  GLOBAL_POSITION_INT: '全球定位数据',
  ATTITUDE: '姿态数据',
  // attitude: '姿态数据',
  onboardControlSensorsPresent: '飞行器传感器状态',
  // Heartbeat: '飞控基本信息',
  VfrHud: '平视显示器数据',
}